var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHorizontalLinesDecoration = function SvgHorizontalLinesDecoration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 270,
    fill: "none",
    viewBox: "0 0 800 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FCD69D",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 9.052,
    d: "m650.846 92.059-453.292 34.536m596.606-14.172L119.546 166.73m675.042-20.729L5 210.577M794.776 179.7l-753.59 61.361m752.611-27.816-568.776 44.852"
  })));
};
export default SvgHorizontalLinesDecoration;